/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

import { faQuestionSquare, IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { EPGImageSliderItem } from '../../../app/shared/epg-image-slider/epg-image-slider.component';
import { getImageSliderFromTaskDatum } from '../../../app/shared/functions';
import { LocationModel, RecordBaseModel, WorkflowItemType } from '../record-base.model';

export class QuestionRecord extends RecordBaseModel {
  itemIcon: IconDefinition = faQuestionSquare;
  itemData?: QuestionRecordData;
  constructor(itemName: string, geolocation?: LocationModel, timestamp?: string) {
    super(itemName, WorkflowItemType.QUESTION, undefined, geolocation, timestamp);
  }

  fromJson(json: any): QuestionRecord | undefined {
    if (!json) return;
    let record = new QuestionRecord(
      json.itemName.value,
      LocationModel.fromJson(json.geolocation),
      json.timestamp?.value
    );
    let questionRecordData = Object.create(QuestionRecordData.prototype);
    record.itemData = questionRecordData.fromJson(json);
    return record;
  }
}

export class QuestionRecordData {
  questionText: string;
  answers: QuestionAnswerRecordData[];
  image?: EPGImageSliderItem;

  constructor(
    questionText: string,
    answers: QuestionAnswerRecordData[] = [],
    image?: EPGImageSliderItem
  ) {
    this.questionText = questionText;
    this.answers = answers;
    this.image = image;
  }

  fromJson(json: any): QuestionRecordData | undefined {
    const questionText = json.questionText.value ?? '';

    let questionAnswerRecordData = Object.create(QuestionAnswerRecordData.prototype);

    let answers: QuestionAnswerRecordData[] = [];

    if (json.answers) {
      for (const answer of json.answers.value) {
        answers.push(
          questionAnswerRecordData.fromJson(
            answer.value.answerText.value ?? '',
            answer.value.isSelected.value ?? false,
            answer.value.notificationTrigger?.value?.isTriggered?.value ?? false
          )
        );
      }
    }

    let image: EPGImageSliderItem | undefined;

    if (json.image) {
      image = getImageSliderFromTaskDatum(json.image);
    }

    return new QuestionRecordData(questionText, answers, image);
  }
}

export class QuestionAnswerRecordData {
  answerText: string;
  isSelected: boolean;
  isTriggered: boolean;

  constructor(answerText: string, isSelected: boolean, isTriggered: boolean) {
    this.answerText = answerText;
    this.isSelected = isSelected;
    this.isTriggered = isTriggered;
  }

  fromJson(
    answerText: string,
    isSelected: boolean,
    isTriggered: boolean
  ): QuestionAnswerRecordData {
    return new QuestionAnswerRecordData(answerText, isSelected, isTriggered);
  }
}
